import { render, staticRenderFns } from "./DangerButton.vue?vue&type=template&id=4dfb3799&scoped=true"
import script from "./DangerButton.vue?vue&type=script&lang=ts"
export * from "./DangerButton.vue?vue&type=script&lang=ts"
import style0 from "./DangerButton.vue?vue&type=style&index=0&id=4dfb3799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb3799",
  null
  
)

export default component.exports